import React, {lazy, Suspense} from 'react';

// Do NOT lazy load this component, it must be included on the initial bundle
import HasAdvisor from './steps/HasAdvisor';
import StepIntro from './steps/StepIntro';
import {structureFactory} from './form';

const Goals = lazy(() => import('./steps/Goals'));
const Age = lazy(() => import('./steps/Age'));
const Income = lazy(() => import('./steps/Income'));
const OwnAssets = lazy(() => import('./steps/OwnAssets'));
const AssetsCash = lazy(() => import('./steps/AssetsCash'));
const AssetsRealEstate = lazy(() => import('./steps/AssetsRealEstate'));
const AssetsInvestments = lazy(() => import('./steps/AssetsInvestments'));
const AssetsRetirement = lazy(() => import('./steps/AssetsRetirement'));
const AssetsOther = lazy(() => import('./steps/AssetsOther'));
const Location = lazy(() => import('./steps/Location'));
const About = lazy(() => import('./steps/About'));
const Animation = lazy(() => import('./steps/Animation'));

export default structureFactory({
  intro: {component: StepIntro},
  hasAdvisor: {component: HasAdvisor, required: ['hasAdvisor']},
  age: {
    component: () => (
      <Suspense fallback={null}>
        <Age />
      </Suspense>
    ),
    required: ['age'],
  },
  location: {
    component: () => (
      <Suspense fallback={null}>
        <Location />
      </Suspense>
    ),
    required: ['location'],
  },
  goals: {
    component: () => (
      <Suspense fallback={null}>
        <Goals />
      </Suspense>
    ),
    required: ['goals'],
  },
  income: {
    component: () => (
      <Suspense fallback={null}>
        <Income />
      </Suspense>
    ),
    required: ['household_income'],
  },
  assets: {
    component: () => (
      <Suspense fallback={null}>
        <OwnAssets />
      </Suspense>
    ),
    required: ['assets'],
  },
  assetsCash: {
    component: () => (
      <Suspense fallback={null}>
        <AssetsCash />
      </Suspense>
    ),
    required: ['assets_cash'],
  },
  assetsRealState: {
    component: () => (
      <Suspense fallback={null}>
        <AssetsRealEstate />
      </Suspense>
    ),
    required: ['assets_real_state'],
  },
  assetsInvestments: {
    component: () => (
      <Suspense fallback={null}>
        <AssetsInvestments />
      </Suspense>
    ),
    required: ['assets_investments'],
  },
  assetsRetirement: {
    component: () => (
      <Suspense fallback={null}>
        <AssetsRetirement />
      </Suspense>
    ),
    required: ['assets_retirement'],
  },
  assetsOther: {
    component: () => (
      <Suspense fallback={null}>
        <AssetsOther />
      </Suspense>
    ),
    required: ['assets_other'],
  },
  about: {
    component: () => (
      <Suspense fallback={null}>
        <About />
      </Suspense>
    ),
    required: ['name', 'last_name', 'email', 'mobile'],
  },
  animation: {
    component: () => (
      <Suspense fallback={null}>
        <Animation />
      </Suspense>
    ),
  },
});
